import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "../services/translate/translate.service";

@Pipe({
  name: "searchFilter",
  pure: false,
})
export class SearchPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}

  transform(items: any[], searchText: string, property: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter((item) => {
      return this._translate
        .instant(item[property])
        .toLowerCase()
        .includes(searchText);
    });
  }
}
